var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.489261 0.446308C0.334172 0.58684 0.211126 0.753787 0.12717 0.937585C0.0432147 1.12138 -5.10618e-07 1.31842 -5.0192e-07 1.51742C-4.93221e-07 1.71641 0.0432147 1.91345 0.12717 2.09725C0.211126 2.28105 0.334172 2.44799 0.489261 2.58853L11.5606 12.6461C11.6838 12.7583 11.8302 12.8473 11.9914 12.908C12.1526 12.9687 12.3253 13 12.4998 13C12.6743 13 12.8471 12.9687 13.0083 12.908C13.1694 12.8473 13.3158 12.7583 13.4391 12.6461L24.5104 2.58852C25.1632 1.99548 25.1632 1.03935 24.5104 0.446307C23.8576 -0.146736 22.8051 -0.146736 22.1522 0.446307L12.4932 9.20883L2.83408 0.434207C2.19459 -0.146733 1.12876 -0.146735 0.489261 0.446308Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.431778258b629500bc3d12d7a464373e.svg";
export { ForwardRef as ReactComponent };